import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Image = styled.img`
  object-fit: cover;
  width: 400px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  border-radius: 10px;
  height: 100%;
  margin-bottom: 15px;
  ${mediaQuery('tablet')} {
    max-height: auto;
    max-width: 350px;
    width: 80%;
  }
`;
